import { FormattedMessage, useIntl } from '@zenbusiness/application-commons-intl';
import WistiaPlayer from '@zenbusiness/zui/WistiaPlayer';

import * as Styled from './HighlightSection.styles';
import { useProductLandingContext } from '../../contexts/useProductLanding';
import { useProductLandingClickstreamProps } from '../../hooks/useProductLandingClickstreamProps';
import { messageFormatValues } from '../../utils/messageFormatValues';

function HighlightSection() {
  const { productConfig } = useProductLandingContext();
  const { highlight } = productConfig;
  const { formatMessage } = useIntl();
  const personalizationClickstreamProps = useProductLandingClickstreamProps();

  if (!highlight) {
    return null;
  }

  return (
    <Styled.Root>
      <Styled.ContentContainer>
        {highlight.icon && (
          <Styled.IconContainer>
            <Styled.Icon alt="" src={highlight.icon} />
          </Styled.IconContainer>
        )}
        <Styled.Header
          subtitle={highlight.subheader && (
            <Styled.CardSubTitle component="p" color="white">
              <FormattedMessage id={highlight.subheader} values={messageFormatValues} />
            </Styled.CardSubTitle>
          )}
          title={highlight.title && (
            <Styled.CardTitle
              size="lg"
              color="white"
            >
              <FormattedMessage id={highlight.title} />
            </Styled.CardTitle>
          )}
        />
        {highlight.bulletPoints && (
          <Styled.BulletList>
            {highlight.bulletPoints.map((bullet) => (
              <Styled.BulletItem key={bullet.title}>
                <FormattedMessage id={bullet.title} />
              </Styled.BulletItem>
            ))}
          </Styled.BulletList>
        )}
      </Styled.ContentContainer>
      <Styled.ContentContainer border>
        {highlight.image ? (
          <Styled.Image
            alt={highlight.alt ? formatMessage({ id: highlight.alt }) : ''}
            src={highlight.image}
          />
        ) : highlight.video && (
        <WistiaPlayer
          clickstreamProps={{
            ...personalizationClickstreamProps,
            videoName: 'registered_agent_video'
          }}
          videoId={highlight.video}
        />
        )}
      </Styled.ContentContainer>
    </Styled.Root>
  );
}

export default HighlightSection;
